import React ,{useState,useEffect}from "react";
import "../join/dashboards.css";
import "../../../common/css/common.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/axios";
import TimerFunction from "../../../common/js/debate_timer";
import MediatorAvatar from "../../mediator/mediator_avatar";
import  secureLocalStorage  from  "react-secure-storage";
import { TopicProvider } from "../../../redux/actions/websocket_actions/topic_action";
import { WebsocketContext } from "../../../websocket/context";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import LoadingSpinner from "../../loader/spinner";
import { RoomIdProvider } from "../../../redux/actions/websocket_actions/roomId_action";
import { createVote,updateVote,getVotes } from "../../../redux/actions/websocket_actions/voting_action";
import { createCollectionIndexedDB ,createCollectionVotingdDB} from "../../../utils/indexed_db";
import { winner_notification } from "../../../utils/notification";
import { clearAllSecureLocalStorage } from "../../../utils/utils";
function Audience(){

    const [ready, val, send] = useContext(WebsocketContext); 
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const debate_id = location.state.debate_id;
    const code = location.state.code
    const room_id = location.state.room_id

    const topic = useSelector((state)=>state.topicReducer);
    const {roomId} = useSelector((state)=>state.roomIdReducer);
    const voting = useSelector((state)=>state.votingReducer);
    const idb = createCollectionIndexedDB();
    const ivd = createCollectionVotingdDB();


    useEffect(()=>{
        return()=>{
            getData();
            getTopicVotes();
        }
    },[])

    if(roomId === null){
        dispatch(RoomIdProvider(room_id));

    }

    const [topicList,setTopicList]=useState(false);
    const [debateDetails,setDebateDetails] = useState(false);
    const [mediator,setMediator] = useState(false);
    const [virtual_id,setVirtualId]=useState();
    const [start,setStart] = useState(false);
    const [topicsVotes,setTopicsVotes] = useState(0)
    const [complete,setComplete] = useState([])
    const [finishDebate,setFinishDebate] = useState(false)
    const [votedTopic,setVotedTopic] = useState([])
    const [currentViewer,setCurrentViewer] = useState(0)
   

    const auth = useSelector((state)=>state.jwtAuthreducer);
    let topicBar=()=>{
        {topicList ? setTopicList(false):setTopicList(true)};
        try{
            axiosInstance.get("votingteam/all/votes",{params:{virtual_id:virtual_id}}).then(
                (res)=>{
                    setTopicsVotes(res.data)
                }
            )
        }
        catch(err){
            throw(err)
        }
    }

    useEffect(()=>{
        const fetchData = async () => {
            try {
              const response = await axiosInstance.get(`/check/start/${debate_id}`);
              setStart(response.data.start);
              setVirtualId(response.data.virtual_id);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          };
        
          fetchData();

    },[])
    useEffect(()=>{
        var temp = JSON.parse(val)
        if(temp.action === 'start'){
            setStart(temp.data)
        }
    },[val])


    useEffect(()=>{
        return ()=>{
            axiosInstance.get("/join/details/audience/",{params:{"code":code}}).then((res) => {
                setDebateDetails(res.data);
                }).catch((error) => {
                console.error(error);
                }) 
        }
       
    },[]);
    useEffect(()=>{
        var temp = JSON.parse(val)
        console.log(temp,"from audience")
        if(temp.action === 'topic'){
            dispatch(TopicProvider(temp.action,temp.data))
            dispatch(getVotes({topic:temp.data,virtual_id:virtual_id}))
        }
        if(temp.action === "mark_topic_finish"){
            handleTopics(temp.data)
        }
        if(temp.action === "finish"){
            deleteAllVotingRecords()
            deleteAllTopicRecords()
            winner_notification(temp.data)
           
        }
        if(temp.action === "announce_winner"){
            clearAllSecureLocalStorage();
            navigate("/winner",{state:{team:temp.data.winner}})
        }
        if(temp.action === "total_connection"){
            setCurrentViewer(temp.data)
        }
    },[val])

    useEffect(()=>{
        
        if((virtual_id)&&(secureLocalStorage.getItem("topic"))){
            dispatch(getVotes({topic:secureLocalStorage.getItem("topic"),virtual_id:virtual_id}))
        }
    },[virtual_id,ready])

    useEffect(()=>{
        if(ready){
         send(JSON.stringify({ "type": 'get_total_members' }));
        }
    },[ready,send])
    console.log(currentViewer,"from audience")

    const updateVoting = async(values)=>{
        if(!complete.includes(secureLocalStorage.getItem(topic))){
            if(values.action === "vote"){
                dispatch(updateVote({virtual_id:virtual_id,team:values.data.team,topic:values.data.topic}))
            }
           
            handleTopicsVotes(values.data.topic)
            
        }
    }

    const handleTopics = (topic)=>{
        const dbPromise = idb.open("bedate-db")
        dbPromise.onsuccess = ()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsData",'readwrite');
            const topicData = tx.objectStore('topicsData');
            let updatedValue = [...complete,topic]
            // console.log(updatedValue,"from handle topics")
            const topics = topicData.put({
                virtual_id:virtual_id,
                topic:updatedValue,
                finished:false
            });
            topics.onsuccess = ()=>{
                tx.oncomplete =()=>{
                    db.close();
                };
                getData()
            }
            topics.onerror = ()=>{
                console.log("an error occured")
            }


        }
    }
    const getData = ()=>{
        const dbPromise = idb.open("bedate-db")       
        dbPromise.onsuccess=()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsData",'readonly');
            const topicData = tx.objectStore('topicsData');
            // const topics = topicData.get({virtual_id:virtaul_id})
            const topics = topicData.getAll()
            topics.onsuccess=(query)=>{
                if(query.srcElement.result[0]){
                    let updatedValue = query.srcElement.result[0].topic
                    setComplete(updatedValue)
                    setFinishDebate(query.srcElement.result[0].finished)
                }

            }
            topics.onerror = (query)=>{
                alert("error")
            }
            tx.oncomplete=()=>{
                db.close()
            }
        }
           
      
    }


    const handleTopicsVotes = (topic)=>{
        const dbPromise = ivd.open("bedate-voting-db")
        dbPromise.onsuccess = ()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsVotes",'readwrite');
            const topicVoted = tx.objectStore('topicsVotes');
            let updatedValue = [...votedTopic,topic]
            const topics = topicVoted.put({
                virtual_id:virtual_id,
                topic:updatedValue,
            });
            topics.onsuccess = ()=>{
                tx.oncomplete =()=>{
                    db.close();
                };
                getTopicVotes()
            }
            topics.onerror = ()=>{
                console.log("an error occured")
            }
    
    
        }
    }

    const getTopicVotes = ()=>{
        const dbPromise = ivd.open("bedate-voting-db")       
        dbPromise.onsuccess=()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsVotes",'readonly');
            const topicData = tx.objectStore('topicsVotes');
            // const topics = topicData.get({virtual_id:virtaul_id})
            const topics = topicData.getAll()
            topics.onsuccess=(query)=>{
                if(query.srcElement.result[0]){
                    let updatedValue = query.srcElement.result[0].topic
                    setVotedTopic(updatedValue)
                    // setComplete(updatedValue)
                    // setFinishDebate(query.srcElement.result[0].finished)
                }
    
            }
            topics.onerror = (query)=>{
                alert("error")
            }
            tx.oncomplete=()=>{
                db.close()
            }
        }
           
      
    }

    const deleteAllTopicRecords = () => {
        const dbName = 'bedate-db';
        const objectStoreName = 'topicsData';
    
        const request = indexedDB.open(dbName);
    
        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction(objectStoreName, 'readwrite');
          const objectStore = transaction.objectStore(objectStoreName);
          const cursorRequest = objectStore.openCursor();
    
          cursorRequest.onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
              cursor.delete();
              cursor.continue();
            }
          };
    
          transaction.oncomplete = () => {
            console.log('All records deleted successfully');
            // Perform any additional actions after deleting all records if needed
          };
    
          transaction.onerror = (event) => {
            console.log('Error deleting records:', event.target.error);
          };
        };
      };
    
      const deleteAllVotingRecords = () => {
        const dbName = 'bedate-voting-db';
        const objectStoreName = 'topicsVotes';
    
        const request = indexedDB.open(dbName);
    
        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction(objectStoreName, 'readwrite');
          const objectStore = transaction.objectStore(objectStoreName);
          const cursorRequest = objectStore.openCursor();
    
          cursorRequest.onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
              cursor.delete();
              cursor.continue();
            }
          };
    
          transaction.oncomplete = () => {
            console.log('All records deleted successfully');
            // Perform any additional actions after deleting all records if needed
          };
    
          transaction.onerror = (event) => {
            console.log('Error deleting records:', event.target.error);
          };
        };
      };
    
   
    return(
        <>
        {start==false
        ?
        <LoadingSpinner/>
        :
        <div className="competitionWrapper">
            <div className="userInfo">
                <div className="user">
                    <span></span> {auth.user ? auth.user.username:""}
                </div>
                <a href="#" className="leaveBtn">Leave</a>
           </div>
            <div className="competitionWrapperContent">
                <div className="debateInfo">
                        <div className="category">
                            School
                        </div>

                        <div className="debateTitle">
                            {debateDetails ? debateDetails.debate.title:""}
                        </div>
                        {topic.action 
                            ?
                            <h1><a id="current_topic_audience">{topic.action === 'topic' ? topic.data : 'No Topic'}</a></h1>
                            :
                            <h1><a id="current_topic_audience">{secureLocalStorage.getItem("topic")===null ? `Topic Will be display here`:secureLocalStorage.getItem("topic")} </a></h1>

                        } 
                        <div className="viewers">
                            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.5 0C4.01621 0 1.76378 1.40288 0.101718 3.68154C-0.0339061 3.86822 -0.0339061 4.12903 0.101718 4.31572C1.76378 6.59712 4.01621 8 6.5 8C8.98379 8 11.2362 6.59712 12.8983 4.31846C13.0339 4.13178 13.0339 3.87097 12.8983 3.68428C11.2362 1.40288 8.98379 0 6.5 0ZM6.67817 6.81675C5.02941 6.92382 3.66784 5.52093 3.77156 3.81606C3.85665 2.41043 4.96026 1.2711 6.32183 1.18325C7.97059 1.07618 9.33216 2.47907 9.22844 4.18394C9.14069 5.58682 8.03708 6.72615 6.67817 6.81675ZM6.59573 5.51544C5.70753 5.5731 4.97356 4.81812 5.03206 3.90117C5.07727 3.14345 5.67296 2.53123 6.40692 2.48181C7.29513 2.42416 8.0291 3.17914 7.97059 4.09609C7.92273 4.85655 7.32704 5.46877 6.59573 5.51544Z"
                                    fill="#BB8DEE" />
                            </svg>
                            {currentViewer} viewers
                        </div>
                    </div>
            
                <div className="debatersSection">
                    <div className="debaterInfo left">
                        <div className="debaterInfoPart">
                            <div className="votes">
                            {voting ? <a>{voting.left_team_vote}</a>:""}
                                <span >votes</span>
                            </div>
                            <div id="left_side_icon" className="debaterImg">
                                <img src={process.env.PUBLIC_URL+ "img/debater-male-left-pic.png" } alt="" title="" width="220" height="220" />
                                <div className="speaking">
                                    <svg width="16" height="24" viewBox="0 0 16 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15.4073 6.23389C15.0814 6.23389 14.8147 6.51441 14.8147 6.85727V11.5326C14.8147 15.4911 11.7628 18.7015 7.99988 18.7015C4.23692 18.7015 1.18506 15.4911 1.18506 11.5326V6.85727C1.18506 6.51441 0.918396 6.23389 0.592471 6.23389C0.266545 6.23389 -0.00012207 6.51441 -0.00012207 6.85727V11.5326C-0.00012207 15.9586 3.25914 19.6054 7.40729 19.9171V22.7535H4.14803C3.8221 22.7535 3.55543 23.034 3.55543 23.3769C3.55543 23.7197 3.8221 24.0002 4.14803 24.0002H12.4443C12.7702 24.0002 13.0369 23.7197 13.0369 23.3769C13.0369 23.034 12.7702 22.7535 12.4443 22.7535H8.59247V19.9171C12.7406 19.6054 15.9999 15.9586 15.9999 11.5326V6.85727C15.9999 6.51441 15.7332 6.23389 15.4073 6.23389Z"
                                            fill="white" />
                                        <path
                                            d="M7.99987 16.8313C10.7851 16.8313 13.0369 14.4624 13.0369 11.5325V5.29874C13.0369 2.36885 10.7851 0 7.99987 0C5.21468 0 2.96283 2.36885 2.96283 5.29874V11.5325C2.96283 14.4624 5.21468 16.8313 7.99987 16.8313ZM4.14801 10.2858H7.70357C8.0295 10.2858 8.29616 10.0053 8.29616 9.66241C8.29616 9.31955 8.0295 9.03903 7.70357 9.03903H4.14801V7.79226H7.70357C8.0295 7.79226 8.29616 7.51174 8.29616 7.16888C8.29616 6.82602 8.0295 6.5455 7.70357 6.5455H4.14801V5.29874H7.70357C8.0295 5.29874 8.29616 5.01822 8.29616 4.67536C8.29616 4.3325 8.0295 4.05198 7.70357 4.05198H4.32579C4.8295 2.43119 6.28135 1.24676 7.99987 1.24676C10.1332 1.24676 11.8517 3.05457 11.8517 5.29874V11.5325C11.8517 13.7767 10.1332 15.5845 7.99987 15.5845C5.86653 15.5845 4.14801 13.7767 4.14801 11.5325V10.2858Z"
                                            fill="white" />
                                    </svg>
                                    <div className="spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="debaterDetail">
                                <div className="name">
                                    Bill Gates
                                    <span>Debater 1</span>
                                </div>
                                {votedTopic.includes(secureLocalStorage.getItem("topic")) ?

                                <span style={{cursor:"pointer"}} href="#" className="likeBtn inactive" id="team1vote">
                                    <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.595854 7.06724C0.655338 7.00605 0.733286 6.97393 0.811902 6.97361H3.16775C3.24682 6.97388 3.32521 7.00611 3.38508 7.06752C3.44536 7.12935 3.48152 7.21575 3.48183 7.30849V15.1651C3.48152 15.2579 3.44536 15.3443 3.38508 15.4061C3.32528 15.4674 3.24698 15.4997 3.168 15.5H0.811789C0.733213 15.4997 0.655311 15.4675 0.595854 15.4064C0.535842 15.3446 0.499975 15.2584 0.5 15.1659V15.1658V7.30786L0.5 7.30772C0.499975 7.21523 0.535842 7.12896 0.595854 7.06724ZM12.9848 14.1342C12.9479 14.2258 12.8941 14.3082 12.8271 14.3772L4.92745 14.4749V7.31182C5.11068 7.09108 5.25736 6.84116 5.36163 6.57196L5.36205 6.57088L6.65442 3.21104L6.68775 3.12438V3.03154V1.04549C6.70707 0.888174 6.78247 0.746416 6.89579 0.646649C7.00998 0.546121 7.15446 0.495115 7.30033 0.50037C7.43308 0.506959 7.56363 0.540755 7.68435 0.600205C7.80575 0.659988 7.91507 0.744671 8.00536 0.849869L8.0053 0.849918L8.01106 0.856395C8.32216 1.20643 8.56246 1.61749 8.71718 2.06563C8.87183 2.51361 8.93767 2.98913 8.91061 3.46408C8.89071 3.79856 8.83256 4.12939 8.73743 4.44973C8.66957 4.66854 8.57571 4.87766 8.45812 5.07238L8.44917 5.08719L8.44127 5.10259C8.42606 5.13223 8.40951 5.16192 8.38609 5.20391C8.3828 5.20981 8.37938 5.21595 8.3758 5.22237L7.9617 5.9657H8.8126H13.6472C13.8406 5.96621 14.0297 6.03511 14.1823 6.16344C14.3353 6.29208 14.4424 6.47301 14.4826 6.67694C14.5228 6.88098 14.4928 7.09259 14.3989 7.2753C14.3051 7.45778 14.1542 7.59857 13.9744 7.67673L13.2285 8.00093L13.8545 8.52013C13.861 8.52552 13.8672 8.53147 13.873 8.53796L13.8797 8.54535L13.8866 8.55248C14.0541 8.72469 14.1504 8.96063 14.1505 9.20921C14.1504 9.38917 14.0998 9.56441 14.0062 9.71405C13.9126 9.86362 13.7803 9.98067 13.6265 10.0531L12.9216 10.3849L13.5169 10.8875C13.6483 10.9984 13.748 11.1465 13.8028 11.3156C13.8576 11.4848 13.8647 11.6668 13.8232 11.8402C13.7817 12.0136 13.6937 12.1699 13.5709 12.2916C13.4483 12.4133 13.2961 12.4956 13.1325 12.5308L12.3084 12.7085L12.8595 13.3465C12.9757 13.4811 13.0414 13.657 13.0409 13.8411L13.0409 13.843C13.041 13.9433 13.0218 14.0422 12.9848 14.1342Z"
                                            stroke="#7024C4" />
                                    </svg>
                                    <span>Vote</span>
                                </span>
                                :
                                <span style={{cursor:"pointer"}} href="#" className="likeBtn" id="team1vote" onClick={()=>updateVoting({action:"vote",data:{"topic":secureLocalStorage.getItem("topic"),"team":"left_team"}})}>
                                    <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.595854 7.06724C0.655338 7.00605 0.733286 6.97393 0.811902 6.97361H3.16775C3.24682 6.97388 3.32521 7.00611 3.38508 7.06752C3.44536 7.12935 3.48152 7.21575 3.48183 7.30849V15.1651C3.48152 15.2579 3.44536 15.3443 3.38508 15.4061C3.32528 15.4674 3.24698 15.4997 3.168 15.5H0.811789C0.733213 15.4997 0.655311 15.4675 0.595854 15.4064C0.535842 15.3446 0.499975 15.2584 0.5 15.1659V15.1658V7.30786L0.5 7.30772C0.499975 7.21523 0.535842 7.12896 0.595854 7.06724ZM12.9848 14.1342C12.9479 14.2258 12.8941 14.3082 12.8271 14.3772L4.92745 14.4749V7.31182C5.11068 7.09108 5.25736 6.84116 5.36163 6.57196L5.36205 6.57088L6.65442 3.21104L6.68775 3.12438V3.03154V1.04549C6.70707 0.888174 6.78247 0.746416 6.89579 0.646649C7.00998 0.546121 7.15446 0.495115 7.30033 0.50037C7.43308 0.506959 7.56363 0.540755 7.68435 0.600205C7.80575 0.659988 7.91507 0.744671 8.00536 0.849869L8.0053 0.849918L8.01106 0.856395C8.32216 1.20643 8.56246 1.61749 8.71718 2.06563C8.87183 2.51361 8.93767 2.98913 8.91061 3.46408C8.89071 3.79856 8.83256 4.12939 8.73743 4.44973C8.66957 4.66854 8.57571 4.87766 8.45812 5.07238L8.44917 5.08719L8.44127 5.10259C8.42606 5.13223 8.40951 5.16192 8.38609 5.20391C8.3828 5.20981 8.37938 5.21595 8.3758 5.22237L7.9617 5.9657H8.8126H13.6472C13.8406 5.96621 14.0297 6.03511 14.1823 6.16344C14.3353 6.29208 14.4424 6.47301 14.4826 6.67694C14.5228 6.88098 14.4928 7.09259 14.3989 7.2753C14.3051 7.45778 14.1542 7.59857 13.9744 7.67673L13.2285 8.00093L13.8545 8.52013C13.861 8.52552 13.8672 8.53147 13.873 8.53796L13.8797 8.54535L13.8866 8.55248C14.0541 8.72469 14.1504 8.96063 14.1505 9.20921C14.1504 9.38917 14.0998 9.56441 14.0062 9.71405C13.9126 9.86362 13.7803 9.98067 13.6265 10.0531L12.9216 10.3849L13.5169 10.8875C13.6483 10.9984 13.748 11.1465 13.8028 11.3156C13.8576 11.4848 13.8647 11.6668 13.8232 11.8402C13.7817 12.0136 13.6937 12.1699 13.5709 12.2916C13.4483 12.4133 13.2961 12.4956 13.1325 12.5308L12.3084 12.7085L12.8595 13.3465C12.9757 13.4811 13.0414 13.657 13.0409 13.8411L13.0409 13.843C13.041 13.9433 13.0218 14.0422 12.9848 14.1342Z"
                                            stroke="#7024C4" />
                                    </svg>
                                    <span>Vote</span>
                                </span>
                                }


                            </div>
                        </div>
                    </div>
                    <div className="center">
                        <div className="timerWrap">
                            <div className="timerTitle">
                                Time Left
                            </div>
                            {debateDetails.debate
                            ?
                            <TimerFunction total_hour={debateDetails.debate.total_hour} total_minutes={debateDetails.debate.total_minutes}/>
                            :
                            ""
                            }
                            {/* <div id="timer" className="timer" data-hours="1" data-minutes="0" data-seconds="0"></div> */}
                            <div className="timeLabels">
                                <span>hr</span>
                                <span>min</span>
                                <span>sec</span>
                            </div>
                        </div>
                        {debateDetails.debate
                        ?
                        <MediatorAvatar debate={debateDetails.debate}/>
                        :
                        ""
                        }
                    </div>
                    <div className="debaterInfo right">
                        <div className="debaterInfoPart">
                            <div className="votes">
                            {voting ? <a>{voting.right_team_vote}</a>:""}
                                <span>votes</span>
                            </div>
                            <div id="right_side_icon" className="debaterImg">
                                <img className="debaterImg" src={process.env.PUBLIC_URL+ 'img/debater-female-right-pic.png'} alt="" title="" width="220"
                                    height="220" />
                                    <div className="speaking">
                                    <svg width="16" height="24" viewBox="0 0 16 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15.4073 6.23389C15.0814 6.23389 14.8147 6.51441 14.8147 6.85727V11.5326C14.8147 15.4911 11.7628 18.7015 7.99988 18.7015C4.23692 18.7015 1.18506 15.4911 1.18506 11.5326V6.85727C1.18506 6.51441 0.918396 6.23389 0.592471 6.23389C0.266545 6.23389 -0.00012207 6.51441 -0.00012207 6.85727V11.5326C-0.00012207 15.9586 3.25914 19.6054 7.40729 19.9171V22.7535H4.14803C3.8221 22.7535 3.55543 23.034 3.55543 23.3769C3.55543 23.7197 3.8221 24.0002 4.14803 24.0002H12.4443C12.7702 24.0002 13.0369 23.7197 13.0369 23.3769C13.0369 23.034 12.7702 22.7535 12.4443 22.7535H8.59247V19.9171C12.7406 19.6054 15.9999 15.9586 15.9999 11.5326V6.85727C15.9999 6.51441 15.7332 6.23389 15.4073 6.23389Z"
                                            fill="white" />
                                        <path
                                            d="M7.99987 16.8313C10.7851 16.8313 13.0369 14.4624 13.0369 11.5325V5.29874C13.0369 2.36885 10.7851 0 7.99987 0C5.21468 0 2.96283 2.36885 2.96283 5.29874V11.5325C2.96283 14.4624 5.21468 16.8313 7.99987 16.8313ZM4.14801 10.2858H7.70357C8.0295 10.2858 8.29616 10.0053 8.29616 9.66241C8.29616 9.31955 8.0295 9.03903 7.70357 9.03903H4.14801V7.79226H7.70357C8.0295 7.79226 8.29616 7.51174 8.29616 7.16888C8.29616 6.82602 8.0295 6.5455 7.70357 6.5455H4.14801V5.29874H7.70357C8.0295 5.29874 8.29616 5.01822 8.29616 4.67536C8.29616 4.3325 8.0295 4.05198 7.70357 4.05198H4.32579C4.8295 2.43119 6.28135 1.24676 7.99987 1.24676C10.1332 1.24676 11.8517 3.05457 11.8517 5.29874V11.5325C11.8517 13.7767 10.1332 15.5845 7.99987 15.5845C5.86653 15.5845 4.14801 13.7767 4.14801 11.5325V10.2858Z"
                                            fill="white" />
                                    </svg>
                                    <div className="spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="debaterDetail">
                                <div className="name">
                                    Bill Gates
                                    <span>Debater 2</span>
                                </div>
                                {votedTopic.includes(secureLocalStorage.getItem("topic")) ?

                                <span style={{cursor:"pointer"}} className={complete.includes(secureLocalStorage.getItem("topic")) ? "likeBtn inactive":"likeBtn"} id="team2vote">
                                    <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.595854 7.06724C0.655338 7.00605 0.733286 6.97393 0.811902 6.97361H3.16775C3.24682 6.97388 3.32521 7.00611 3.38508 7.06752C3.44536 7.12935 3.48152 7.21575 3.48183 7.30849V15.1651C3.48152 15.2579 3.44536 15.3443 3.38508 15.4061C3.32528 15.4674 3.24698 15.4997 3.168 15.5H0.811789C0.733213 15.4997 0.655311 15.4675 0.595854 15.4064C0.535842 15.3446 0.499975 15.2584 0.5 15.1659V15.1658V7.30786L0.5 7.30772C0.499975 7.21523 0.535842 7.12896 0.595854 7.06724ZM12.9848 14.1342C12.9479 14.2258 12.8941 14.3082 12.8271 14.3772L4.92745 14.4749V7.31182C5.11068 7.09108 5.25736 6.84116 5.36163 6.57196L5.36205 6.57088L6.65442 3.21104L6.68775 3.12438V3.03154V1.04549C6.70707 0.888174 6.78247 0.746416 6.89579 0.646649C7.00998 0.546121 7.15446 0.495115 7.30033 0.50037C7.43308 0.506959 7.56363 0.540755 7.68435 0.600205C7.80575 0.659988 7.91507 0.744671 8.00536 0.849869L8.0053 0.849918L8.01106 0.856395C8.32216 1.20643 8.56246 1.61749 8.71718 2.06563C8.87183 2.51361 8.93767 2.98913 8.91061 3.46408C8.89071 3.79856 8.83256 4.12939 8.73743 4.44973C8.66957 4.66854 8.57571 4.87766 8.45812 5.07238L8.44917 5.08719L8.44127 5.10259C8.42606 5.13223 8.40951 5.16192 8.38609 5.20391C8.3828 5.20981 8.37938 5.21595 8.3758 5.22237L7.9617 5.9657H8.8126H13.6472C13.8406 5.96621 14.0297 6.03511 14.1823 6.16344C14.3353 6.29208 14.4424 6.47301 14.4826 6.67694C14.5228 6.88098 14.4928 7.09259 14.3989 7.2753C14.3051 7.45778 14.1542 7.59857 13.9744 7.67673L13.2285 8.00093L13.8545 8.52013C13.861 8.52552 13.8672 8.53147 13.873 8.53796L13.8797 8.54535L13.8866 8.55248C14.0541 8.72469 14.1504 8.96063 14.1505 9.20921C14.1504 9.38917 14.0998 9.56441 14.0062 9.71405C13.9126 9.86362 13.7803 9.98067 13.6265 10.0531L12.9216 10.3849L13.5169 10.8875C13.6483 10.9984 13.748 11.1465 13.8028 11.3156C13.8576 11.4848 13.8647 11.6668 13.8232 11.8402C13.7817 12.0136 13.6937 12.1699 13.5709 12.2916C13.4483 12.4133 13.2961 12.4956 13.1325 12.5308L12.3084 12.7085L12.8595 13.3465C12.9757 13.4811 13.0414 13.657 13.0409 13.8411L13.0409 13.843C13.041 13.9433 13.0218 14.0422 12.9848 14.1342Z"
                                            stroke="#7024C4" />
                                    </svg>
                                    <span>Vote</span>
                                </span>
                                    :
                                <span style={{cursor:"pointer"}} className={complete.includes(secureLocalStorage.getItem("topic")) ? "likeBtn inactive":"likeBtn"} id="team2vote" onClick={()=>updateVoting({action:"vote",data:{"topic":secureLocalStorage.getItem("topic"),"team":"right_team"}})}>
                                    <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.595854 7.06724C0.655338 7.00605 0.733286 6.97393 0.811902 6.97361H3.16775C3.24682 6.97388 3.32521 7.00611 3.38508 7.06752C3.44536 7.12935 3.48152 7.21575 3.48183 7.30849V15.1651C3.48152 15.2579 3.44536 15.3443 3.38508 15.4061C3.32528 15.4674 3.24698 15.4997 3.168 15.5H0.811789C0.733213 15.4997 0.655311 15.4675 0.595854 15.4064C0.535842 15.3446 0.499975 15.2584 0.5 15.1659V15.1658V7.30786L0.5 7.30772C0.499975 7.21523 0.535842 7.12896 0.595854 7.06724ZM12.9848 14.1342C12.9479 14.2258 12.8941 14.3082 12.8271 14.3772L4.92745 14.4749V7.31182C5.11068 7.09108 5.25736 6.84116 5.36163 6.57196L5.36205 6.57088L6.65442 3.21104L6.68775 3.12438V3.03154V1.04549C6.70707 0.888174 6.78247 0.746416 6.89579 0.646649C7.00998 0.546121 7.15446 0.495115 7.30033 0.50037C7.43308 0.506959 7.56363 0.540755 7.68435 0.600205C7.80575 0.659988 7.91507 0.744671 8.00536 0.849869L8.0053 0.849918L8.01106 0.856395C8.32216 1.20643 8.56246 1.61749 8.71718 2.06563C8.87183 2.51361 8.93767 2.98913 8.91061 3.46408C8.89071 3.79856 8.83256 4.12939 8.73743 4.44973C8.66957 4.66854 8.57571 4.87766 8.45812 5.07238L8.44917 5.08719L8.44127 5.10259C8.42606 5.13223 8.40951 5.16192 8.38609 5.20391C8.3828 5.20981 8.37938 5.21595 8.3758 5.22237L7.9617 5.9657H8.8126H13.6472C13.8406 5.96621 14.0297 6.03511 14.1823 6.16344C14.3353 6.29208 14.4424 6.47301 14.4826 6.67694C14.5228 6.88098 14.4928 7.09259 14.3989 7.2753C14.3051 7.45778 14.1542 7.59857 13.9744 7.67673L13.2285 8.00093L13.8545 8.52013C13.861 8.52552 13.8672 8.53147 13.873 8.53796L13.8797 8.54535L13.8866 8.55248C14.0541 8.72469 14.1504 8.96063 14.1505 9.20921C14.1504 9.38917 14.0998 9.56441 14.0062 9.71405C13.9126 9.86362 13.7803 9.98067 13.6265 10.0531L12.9216 10.3849L13.5169 10.8875C13.6483 10.9984 13.748 11.1465 13.8028 11.3156C13.8576 11.4848 13.8647 11.6668 13.8232 11.8402C13.7817 12.0136 13.6937 12.1699 13.5709 12.2916C13.4483 12.4133 13.2961 12.4956 13.1325 12.5308L12.3084 12.7085L12.8595 13.3465C12.9757 13.4811 13.0414 13.657 13.0409 13.8411L13.0409 13.843C13.041 13.9433 13.0218 14.0422 12.9848 14.1342Z"
                                            stroke="#7024C4" />
                                    </svg>
                                    <span>Vote</span>
                                </span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={topicList ? "topicsMenu show" : "topicsMenu"}>
                <div className="topicsBtn" onClick={()=>topicBar()}>
                    Topic
                </div>
                <div className="topicsList">
                    <ul>
                        {/* <!-- use className done when topic is done inseted of active --> */}
                        {debateDetails ?
                        <>
                        {debateDetails.details.topics[0].map((element,index)=>(
                        <li className={complete.includes(element) ? "active done":"active"}>
                            <div className="right" key={index}>
                                <div className="title">{element}</div>
                                <div className="votes">
                                    <div>
                                        T1
                                        <span>
                                            {topicsVotes[element]?topicsVotes[element][0]:0}
                                        </span>
                                    </div>
                                    <div>
                                        T2
                                        <span>
                                            {topicsVotes[element]?topicsVotes[element][1]:0}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                        ))}
                        </>
                        :
                        "Loading..."
                        
                         }
                    
                        {/* <li className="active">
                            <div className="right">
                                <div className="title">Topic 2</div>
                                <div className="votes">
                                    <div>
                                        D1
                                        <span id="#">
                                            123
                                        </span>
                                    </div>
                                    <div>
                                        D2
                                        <span >
                                            3232
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li> */}
                        
                    </ul>

                    <img src={process.env.PUBLIC_URL+ 'img/bedater-logo.png' } className="logo" alt="" title="" width="50" />
                </div>
            </div>

            <img src={process.env.PUBLIC_URL+ 'img/competition-bedater-logo-grey.png' } className="greyLogo" alt="" title="" width="50" />
        </div>
        }
        </>

    );
}
export default Audience;